import { capitalizeFirstLetter } from '@autone/utils';
import { type FC } from 'react';

import { ProductInfo } from '../ProductInfo';

export const ProductTitle: FC<{ title: string | null; className?: string }> = ({
  title,
  className,
}) => {
  if (!title) {
    return null;
  }

  const capitalizedTitle = capitalizeFirstLetter(title);
  return <ProductInfo.Title className={className} value={capitalizedTitle} />;
};
